<template>
    <div
        class="nav-user-menu"
        data-test="nav-user-menu">
        <DesktopUserInfoMenu :config="config"></DesktopUserInfoMenu>
    </div>
</template>

<script lang="ts">
    import type { IDesktopUserInfoMenuConfig } from "@eg_ui/src/components/globals/DesktopUserInfoMenu/DesktopUserInfoMenu.vue";

    export type INavUserMenuConfig = IDesktopUserInfoMenuConfig;

    export interface INavUserMenuProps {
        config: INavUserMenuConfig;
    }
</script>

<script setup lang="ts">
    import DesktopUserInfoMenu from "@eg_ui/src/components/globals/DesktopUserInfoMenu/DesktopUserInfoMenu.vue";

    const { config } = defineProps<INavUserMenuProps>();
</script>

<style lang="scss">
    @use "./NavUserMenu.scss";
</style>
